
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserRole } from "@/hooks/useUserRole";
import { UserList } from "@/components/users/UserList";

const Users = () => {
  const { isSuperAdmin, loading } = useUserRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isSuperAdmin()) {
      navigate("/");
    }
  }, [loading, isSuperAdmin, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isSuperAdmin()) {
    return null;
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">User Management</h1>
      <UserList />
    </div>
  );
};

export default Users;
